import { render } from "./SelectProject.vue?vue&type=template&id=6e74b560"
import script from "./SelectProject.vue?vue&type=script&lang=js"
export * from "./SelectProject.vue?vue&type=script&lang=js"
script.render = render

export default script